// src/app/useHashScroll.ts
// Scrolls to the element named by the URL hash (/user/settings#password)
// once `ready` is true, i.e. after the page's data has rendered.

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function useHashScroll(ready = true) {
  const { hash } = useLocation();
  useEffect(() => {
    if (!ready || !hash) return;
    const t = window.setTimeout(() => {
      document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 60);
    return () => window.clearTimeout(t);
  }, [hash, ready]);
}
